<template>
  <div class="bg-white p-b-10">
    <div style="margin-top: -20px">
      <h4 class="m-b-0 ml-1">Form Announcement</h4>
      <p class="hint-text ml-1">Formulir untuk membuat Pengumuman</p>
    </div>
    <form class="" @submit.prevent="updateNotif">
      <loader_component v-if="is_loading" />
      <div class="row" v-else>
        <div class="col-md-6 px-1">
          <div class="mt-3">
            <label for="">Kode Pengumuman</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control rounded-sm"
                placeholder="Masukkan Kode Pengumuman"
                v-model="announcement.code"
              />
            </div>
          </div>
          <div class="mt-3">
            <label for="">Judul</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control rounded-sm"
                placeholder="Masukkan Judul Pengumuman"
                v-model="announcement.title"
              />
            </div>
          </div>
          <div class="mt-3">
            <label for="">Konten</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control rounded-sm"
                placeholder="Masukkan Konten Pengumuman"
                v-model="announcement.content"
              />
            </div>
          </div>
          <div class="mt-3">
            <label for="">Tipe</label>
            <div class="input-group">
              <select
                class="form-control rounded-sm"
                v-model="announcement.type"
              >
                <option value="info">Informasi</option>
                <option value="danger">Peringatan</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6 px-1">
          <div class="mt-3">
            <label for="">Link</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control rounded-sm"
                placeholder="Masukkan Kode Pengumuman"
                v-model="announcement.link"
              />
            </div>
          </div>
          <div class="mt-3">
            <label for="">Nama Tombol Link</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control rounded-sm"
                placeholder="Masukkan Nama Tombol Link Pengumuman"
                v-model="announcement.name_link"
              />
            </div>
          </div>
          <div class="mt-3">
            <label for="">Status</label>
            <div class="input-group">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="status"
                  value="1"
                  v-model="announcement.status"
                />
                <label class="custom-control-label" for="status">
                  {{ announcement.status == 1 ? "Nonaktifkan" : "Aktifkan" }}
                </label>
              </div>
            </div>
          </div>
          <button class="btn btn-success float-right mt-5" type="submit">
            Ubah Pengumuman
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import loader_component from "../../components/loader.vue";

$.pgNotificationimport = notif;

export default {
  name: "tab_announcement",
  components: {
    loader_component,
  },
  data() {
    return {
      is_loading: true,
      announcement: {
        code: "",
        content: "",
        link: "",
        name: "",
        name_link: "",
        status: null,
        title: "",
        type: "",
      },
    };
  },
  created() {
    this.getNotif();
  },
  methods: {
    getNotif() {
      this.is_loading = true;
      let api = process.env.VUE_APP_API_URL + "alert-message";
      this.$http
        .get(api)
        .then((res) => {
          this.announcement = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    updateNotif() {
      let params = {
        code: this.announcement.code,
        content: this.announcement.content,
        link: this.announcement.link,
        name_link: this.announcement.name_link,
        status: this.announcement.status == true ? 1 : 0,
        title: this.announcement.title,
        type: this.announcement.type,
      };
      let api = process.env.VUE_APP_API_URL + "alert-message/update";
      this.$http
        .put(api, params)
        .then(() => {
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Pengumuman berhasil diubah!',
              position: "top-right",
              timeout: 5000,
              type: "success",
            })
            .show();
          this.getNotif();
        })
        .catch(() => {
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Gagal!</b> Terjadi kesalahan saat mengubah pengumuman!',
              position: "top-right",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
  },
};
</script>
<style>
.hover:hover {
  opacity: 0.5;
}
</style>